export enum ChatbotQuestionType {
  SINGLE_CHOICE = 'single-choice',
  MULTIPLE_CHOICE = 'multiple-choice',
  TEXT = 'text',
}

export interface IChatbotQuestion {
  id: string;
  type: ChatbotQuestionType;
  title: string;
  description?: string;
  options?: string[];
  answer?: string | string[];
}
